import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { isDevEnv } from '../utils';
import { buildContext } from './buildContext';
export let moduleClient;
export const [useInsights, InsightsContextProvider] = buildContext();
export const InsightsProvider = ({ insightsApi, children }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [isCookieOk, setIsCookieOk] = useState(undefined);
    const initSession = (designId, source) => {
        if (isConnected && !isInitialized) {
            insightsApi.moduleClient.initPlanningSession(designId, source);
            setIsInitialized(true);
        }
    };
    const connectApp = useCallback(() => {
        try {
            connect(insightsApi);
            setIsConnected(true);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.warn('Failed to connect to Insights', err);
            setIsConnected(false);
        }
    }, [insightsApi]);
    const disconnectApp = useCallback(() => {
        insightsApi.disconnect();
        setIsConnected(false);
    }, [insightsApi]);
    useEffect(() => {
        if (insightsApi?.moduleClient) {
            setIsCookieOk(true);
        }
    }, [insightsApi, isCookieOk]);
    useEffect(() => {
        if (isCookieOk && !isConnected) {
            connectApp();
        }
        if (!isCookieOk && isConnected) {
            disconnectApp();
        }
    }, [isCookieOk, isConnected, connectApp, disconnectApp]);
    return (_jsx(InsightsContextProvider, { value: { insightsApi, isInitialized, initSession, moduleClient }, children: children }));
};
const connect = (api) => {
    moduleClient = api.moduleClient({
        moduleId: 'guida',
        moduleVersion: '1.0',
        dev: isDevEnv(),
        abVersionName: undefined,
        abVersionVariation: undefined
    });
};
//# sourceMappingURL=insights.js.map